import React from 'react'
import { WorkspaceMinimalFragment } from '@sketch/gql-types'
import { getWorkspaceMainRoute, hasPermissionForRoute } from '../../utils'
import { Redirect } from 'react-router'

interface UserRoleGateProps {
  workspace: WorkspaceMinimalFragment
  pathname?: string
  children: React.ReactNode
}

export const UserRoleGate: React.FCC<UserRoleGateProps> = props => {
  const { workspace, pathname, children } = props

  if (pathname && workspace && !hasPermissionForRoute(workspace, pathname)) {
    const to = getWorkspaceMainRoute(workspace)

    return <Redirect to={to} />
  }

  return <>{children}</>
}
